import { useEffect } from 'react';

import { selectWorkflowAuthor } from '../features/workflow/selectors';
import { setWorkflowAuthor } from '../features/workflow/workflowSlice';
import { useAppDispatch, useAppSelector } from '../hooks';

export type UserData = {
  name: string;
  email: string;
};

export type User = {
  userData: UserData;
};

export const useInitializeWorkflowAuthor = (
  user?: User,
  isExistingWorkflow: boolean = false
) => {
  const dispatch = useAppDispatch();
  const currentAuthor = useAppSelector(selectWorkflowAuthor);

  useEffect(() => {
    // Only set the author for new workflows and if it's still the default value
    if (!isExistingWorkflow && user && currentAuthor === 'Author here') {
      // Prefer the user's name, fall back to email if name is not available
      const authorName =
        user.userData.name || user.userData.email || 'Unknown User';
      dispatch(setWorkflowAuthor(authorName));
    }
  }, [dispatch, user, isExistingWorkflow, currentAuthor]);
};
